import axiosInstance from "../libs/axiosInstance";

/**
 * Fetch paginated in-app notifications with optional query filters.
 * @param {Object} params - Query parameters: { is_read, notification_type, priority, page, page_size }
 */
export const getNotifications = async (params = {}) => {
  const response = await axiosInstance.get("/notifications/", { params });
  return response.data;
};

/**
 * Fetch unread in-app notification count for UI badges.
 * Returns { unread_count: number }
 */
export const getUnreadNotificationCount = async () => {
  const response = await axiosInstance.get("/notifications/unread-count/");
  return response.data;
};

/**
 * Mark a single notification as read.
 * @param {string} notificationId - UUID of the notification
 */
export const markNotificationAsRead = async (notificationId) => {
  const response = await axiosInstance.patch(`/notifications/${notificationId}/read/`);
  return response.data;
};

/**
 * Mark all or selected notifications as read.
 * @param {string[]|null} notificationIds - Optional list of UUIDs. If empty/null, marks all as read.
 */
export const markAllNotificationsAsRead = async (notificationIds = null) => {
  const payload = Array.isArray(notificationIds) && notificationIds.length > 0
    ? { notification_ids: notificationIds }
    : {};
  const response = await axiosInstance.post("/notifications/mark-all-read/", payload);
  return response.data;
};

/**
 * Dismiss or delete a notification.
 * @param {string} notificationId - UUID of the notification
 */
export const deleteNotification = async (notificationId) => {
  const response = await axiosInstance.delete(`/notifications/${notificationId}/`);
  return response.data;
};

/**
 * Fetch user notification delivery preferences.
 */
export const getNotificationPreferences = async () => {
  const response = await axiosInstance.get("/notifications/preferences/");
  return response.data;
};

/**
 * Update user notification preferences.
 * @param {Object} preferences - Updated preference fields
 */
export const updateNotificationPreferences = async (preferences) => {
  const response = await axiosInstance.patch("/notifications/preferences/", preferences);
  return response.data;
};
